export default __webpack_public_path__ + "static/media/bookmark_outline_blue.4ef7aad0.svg";